import { useDispatch, useSelector } from "react-redux";
import {
  getConsolidatedInvoiceDetails,
} from "src/redux/slices/invoiceSlice";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import InvoicesDetailsPopup from "../InvoicesDetailsPopup";
import {
  generateConsolidatedInvoiceURLHandler,
  isConsolidatedInvoiceNotPaid,
} from "src/utils/common";
import { ConfirmDialog } from "primereact/confirmdialog";
import InvoiceFooter from "../InvoiceFooter";
import ConsolidatedInvoiceDefaultView from "./ConsolidatedInvoiceDefaultView";
import ConsolidatedInvoicePrintView from "./ConsolidatedInvoicePrintView";
import { useLocation } from "react-router";
import { setPaymentInitiator } from "src/redux/slices/lookupSlice";
import { PaymentInitiator } from "src/resources/enum";

const ConsolidatedInvoiceDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation(["common", "invoice", "registration"]);
  const { selectedItems } = useSelector((state: any) => state.invoices);
  const { consolidatedInvoiceId, status } = useSelector(
    (state: any) => state.invoices.consolidatedInvoiceDetailsPopupData
  );

  const { isInvoicesDetailsPopupOpen } = useSelector(
    (state: any) => state.invoices
  );

  useEffect(() => {
    dispatch(setPaymentInitiator(PaymentInitiator.Invoice));
  }, []);


  const contentRef = useRef(null);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlConsolidatedInvoiceId = searchParams.get("consolidatedInvoiceId");
    if (urlConsolidatedInvoiceId && !consolidatedInvoiceId) {
      dispatch(getConsolidatedInvoiceDetails(urlConsolidatedInvoiceId) as any);
    }
  }, [location.search, consolidatedInvoiceId,dispatch]);

  function payInvoiceHandler(): void {
    generateConsolidatedInvoiceURLHandler(dispatch, consolidatedInvoiceId);
  }

  const showPayButton =
    selectedItems?.length > 0 && isConsolidatedInvoiceNotPaid(status);

  return (
    <div className="px-2 pt-3 building-details-form view-invoice-grid">
      <ConfirmDialog />
      <div className="grid-outer-wrapper p-2">
        <h2>{t("consolidatedInvoiceTitle")}</h2>
        <div className="grid-inner-wrapper mb-3">
          <div className="p-0 pt-3 building-details-form">
            <div className="w-100" ref={contentRef}>
              <ConsolidatedInvoiceDefaultView />
              <ConsolidatedInvoicePrintView />
            </div>
          </div>
        </div>
        <InvoiceFooter
          showPayButton={showPayButton}
          contentRef={contentRef}
          payInvoiceHandler={payInvoiceHandler}
        />
      </div>

      {isInvoicesDetailsPopupOpen && <InvoicesDetailsPopup />}
    </div>
  );
};

export default ConsolidatedInvoiceDetails;
